export default __webpack_public_path__ + "static/media/weather.3071f2e6.png";